import axios from '@/libs/api.request';

export const login = (data) => {
  return axios.request({
    url: '/admin/Login/Login',
    data,
    method: 'post',
  });
};

/**
 * AuthCenter 统一认证回调：用 code 换取 OA token
 * @param {Object} data - 请求体
 * @param {string} data.code - 授权码（AuthCenter 回调 URL 中的 code）
 * @param {string} data.redirectUri - 需与申请 code 时一致，如 "http://localhost:8080#/auth/callback"
 */
export const authCallback = (data) => {
  return axios.request({
    url: '/api/AuthCenter/AuthCallback',
    data,
    method: 'post',
  });
};

export const changePwd = (params) => {
  return axios.request({
    url: '/admin/UserControl/Edit',
    method: 'post',
    data: params,
  });
};

// 忘记密码 - 发送验证码（手机号）
export const sendForgotPwdCode = (data) => {
  return axios.request({
    url: '/admin/ForgotPassword/SendCode',
    method: 'post',
    data,
  });
};

// 忘记密码 - 重置密码（手机号 + 验证码）
export const resetPasswordByPhone = (data) => {
  return axios.request({
    url: '/admin/ForgotPassword/Reset',
    method: 'post',
    data,
  });
};

// 手机号登录 - 发送验证码（仅支持已绑定 F_MobilePhone 的用户）
export const sendPhoneLoginCode = (data) => {
  return axios.request({
    url: '/admin/PhoneLogin/SendCode',
    method: 'post',
    data,
  });
};

// 手机号登录 - 手机号 + 验证码登录
export const phoneLogin = (data) => {
  return axios.request({
    url: '/admin/PhoneLogin/Login',
    method: 'post',
    data,
  });
};

/**
 * 查找用户下拉数据
 */
export const getEmployee = () => {
  return axios.request({
    url: '/admin/SysUser/Ddllist',
    method: 'get',
  });
};

/**
 * 获取登录数量
 */
export const LoginCount = () => {
  return axios.request({
    url: '/admin/User/LoginCount',
    method: 'post',
    data: params,
  });
};

//获取用户信息
export const getUserList = (params) => {
  return axios.request({
    url: '/auth/platform/PlaUser/getUserList',
    method: 'post',
    data: params,
  });
};
//获取角色信息
export const getRoleList = (params) => {
  return axios.request({
    url: '/auth/platform/PlaRole/getRoleList',
    method: 'get',
    params,
  });
};
//根据功能码获取角色
export const getRoleByMenuCode = (params) => {
  return axios.request({
    url: '/auth/platform/PlaRole/listByMenuFun',
    method: 'get',
    params,
  });
};

//权限对象查询
export const getlistByMenuFunObj = (params) => {
  return axios.request({
    url: '/auth/platform/PlaRole/listByMenuFunObj',
    method: 'get',
    params,
  });
};

//查询菜单标
export const getPlanMenuCodeList = (params) => {
  return axios.request({
    url: '/auth/platform/PlaMenu/queryMenuCodeList',
    method: 'get',
    params,
  });
};

//添加用户
export const addUser = (params) => {
  return axios.request({
    url: '/auth/platform/PlaUser/addUser',
    method: 'POST',
    data: params,
  });
};

//修改用户
export const putUser = (params) => {
  return axios.request({
    url: '/auth/platform/PlaUser/putUser',
    method: 'PUT',
    data: params,
  });
};

//删除用户
export const delUser = (params) => {
  return axios.request({
    url: '/auth/platform/PlaUser/delUser',
    method: 'DELETE',
    data: params,
  });
};

//添加菜单码
export const addMenu = (params) => {
  return axios.request({
    url: '/admin/SysAuthMenuCode/CreateObject',
    method: 'POST',
    data: params,
  });
};

//修改菜单码
export const putMenu = (params) => {
  return axios.request({
    url: '/admin/SysAuthMenuCode/EditObject',
    method: 'POST',
    data: params,
  });
};

//删除菜单码
export const delMenu = (params) => {
  return axios.request({
    url: '/admin/SysAuthMenuCode/DeleteObject',
    method: 'DELETE',
    data: params,
  });
};

//添加菜单码
export const addMenuItem = (params) => {
  return axios.request({
    url: '/admin/SysAuthMenu/CreateObject',
    method: 'POST',
    data: params,
  });
};

//修改菜单码
export const putMenuItem = (params) => {
  return axios.request({
    url: '/admin/SysAuthMenu/EditObject',
    method: 'POST',
    data: params,
  });
};

//删除菜单码
export const delMenuItem = (params) => {
  return axios.request({
    url: '/admin/SysAuthMenu/DeleteObject',
    method: 'POST',
    data: params,
  });
};

//添加菜单码
export const queryMenuInfo = (params) => {
  return axios.request({
    url: '/auth/platform/PlaMenu/queryMenuInfo',
    method: 'POST',
    data: params,
  });
};

//获取组织树
export const getOrgNode = (params) => {
  return axios.request({
    url: '/admin/SysOrganizationMember/GetPageList',
    method: 'POST',
    data: params,
  });
};
//获取维修类型
export const GetRepairTypeList = (params) => {
  return axios.request({
    url: '/admin/SysRepairtype/GetPageList',
    method: 'POST',
    data: params,
  });
};
//获取楼宇组织
export const GetBuildingPageList = (params) => {
  return axios.request({
    url: '/admin/SysBuilding/GetPageList',
    method: 'POST',
    data: params,
  });
};
//获取组织树
export const getMyDepartment = (params) => {
  return axios.request({
    url: '/admin/SysOrganizationMember/GetPageList',
    method: 'POST',
    data: params,
  });
};

//获取已分配角色组织列表
export const queryRoleOrgList = (params) => {
  return axios.request({
    url: '/auth/platform/Organization/queryRoleOrgList',
    method: 'POST',
    data: params,
  });
};

//获取未分配角色组织列表
export const queryCanRoleOrgList = (params) => {
  return axios.request({
    url: '/auth/platform/Organization/queryCanRoleOrgList',
    method: 'POST',
    data: params,
  });
};

export const saveRoleOrg = (params) => {
  return axios.request(
    {
      url: '/auth/platform/Organization/saveRoleOrg',
      method: 'post',
      data: params,
    },
    'application/json',
  );
};

export const delRoleOrg = (params) => {
  return axios.request(
    {
      url: '/auth/platform/Organization/delRoleOrg',
      method: 'post',
      data: params,
    },
    'application/json',
  );
};

//一键已读
export const oneClickRead = (params) => {
  return axios.request({
    url: '/admin/Inform/EditBatchInform ',
    method: 'POST',
    data: params,
  });
};
//设置未读
export const setIsRead = (params) => {
  return axios.request({
    url: '/admin/Inform/IsRead',
    method: 'POST',
    data: params,
  });
};
//获取通知列表
export const getInformList = (params) => {
  return axios.request({
    url: '/admin/Inform/GetInformList',
    method: 'POST',
    data: params,
  });
};

//获取组织类型
export const getOrgType = (params) => {
  return axios.request({
    url: '/auth/platform/Organization/queryType',
    method: 'POST',
    data: params,
  });
};
//获取添加组织
export const updateOrg = (params) => {
  return axios.request({
    url: '/admin/SysOrganizationMember/EditObject',
    method: 'POST',
    data: params,
  });
};
//修改组织
export const updateBuilding = (params) => {
  return axios.request({
    url: '/admin/SysBuilding/EditObject',
    method: 'POST',
    data: params,
  });
};
//修改维修类型
export const updaterepairtype = (params) => {
  return axios.request({
    url: '/admin/SysRepairtype/EditObject',
    method: 'POST',
    data: params,
  });
};
//获取添加组织
export const addOrg = (params) => {
  return axios.request({
    url: '/admin/SysOrganizationMember/CreateObject',
    method: 'POST',
    data: params,
  });
};
export const getData = (url, params) => {
  return axios.request({
    url: url,
    method: 'get',
    params,
  });
};

//添加维修类型
export const addRepairtype = (params) => {
  return axios.request({
    url: '/admin/SysRepairtype/CreateObject',
    method: 'POST',
    data: params,
  });
};
//添加楼宇组织
export const addBuilding = (params) => {
  return axios.request({
    url: '/admin/SysBuilding/CreateObject',
    method: 'POST',
    data: params,
  });
};
//修改经纬度
export const navigationEdit = (params) => {
  return axios.request({
    url: '/admin/Navigation/Edit',
    method: 'POST',
    data: params,
  });
};
//新增经纬度
export const navigationInsert = (params) => {
  return axios.request({
    url: '/admin/Navigation/Insert',
    method: 'POST',
    data: params,
  });
};
//同步钉钉员工信息
export const syncEmp = (params) => {
  return axios.request({
    url: '/api/xwapi/commerceOrder/getDeptAndUser',
    method: 'POST',
    data: params,
  });
};

//获取字典node
export const getDicNode = (params) => {
  return axios.request({
    url: '/auth/platform/Org/queryPageList',
    method: 'POST',
    data: params,
  });
};

//新增角色
export const addRole = (params) => {
  return axios.request({
    url: '/auth/platform/PlaRole/addRole',
    method: 'POST',
    data: params,
  });
};

//修改角色
export const putRole = (params) => {
  return axios.request({
    url: '/auth/platform/PlaRole/putRole',
    method: 'PUT',
    data: params,
  });
};

//删除角色
export const delRole = (params) => {
  return axios.request({
    url: '/auth/platform/PlaRole/delRole',
    method: 'DELETE',
    data: params,
  });
};
